import { TABLE_TYPES } from '../../tableTypes';
import { SECTION_4_TABLE_NAMES_V1 as SECTION_4_TABLE_NAMES } from '../tableNames';

export const SECTION_4_TABLES = {
  [SECTION_4_TABLE_NAMES.PRIVATE_EQUITY]: {
    questionLevels: [
      {
        columns: {
          fund_id_field: {
            name: 'Private fund identification number of the reporting fund',
            level: '(b)'
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS1]: {
    questionLevels: [
      {
        columns: {
          has_guarantee_obligations: {
            name: 'Do you or any of your related persons guarantee, or are you or any of your related persons otherwise obligated to satisfy, the obligations of any portfolio company in which the reporting fund invests?',
            level: '(a)'
          },
          amount: {
            name: 'If you responded "yes" to Question 72(a) above, report the total dollar value of all such guarantees and other obligations.',
            level: '(b)'
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS2]: {
    questionLevels: [
      {
        columns: {
          highest_debt_to_equity_ratio: {
            name: 'What is the weighted average debt-to-equity ratio of the controlled portfolio companies in which the reporting fund invests (expressed as a decimal to the tenths place)?'
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS4]: {
    questionLevels: [
      {
        columns: {
          aggregate_gross_asset_value: {
            name: "What is the aggregate gross asset value of the reporting fund's controlled portfolio companies?"
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS5]: {
    questionLevels: [
      {
        columns: {
          aggregate_principal_amount_as_current_liabilities: {
            name: "What is the aggregate principal amount of borrowings categorized as current liabilities on the most recent balance sheets of the reporting fund's controlled portfolio companies?"
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS6]: {
    questionLevels: [
      {
        columns: {
          aggregate_principal_amount_as_long_term_liabilities: {
            name: "What is the aggregate principal amount of borrowings categorized as long-term liabilities on the most recent balance sheets of the reporting fund's controlled portfolio companies?"
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS7]: {
    questionLevels: [
      {
        columns: {
          percentage_payment_in_kind_or_zero_coupon_debt: {
            name: "What percentage of the aggregate borrowings of the reporting fund's controlled portfolio companies is payment-in-kind (PIK) or zero-coupon debt?"
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.DEFAULT_EVENT]: {
    questionLevels: [
      {
        columns: {
          has_default_for_borrowed_money: {
            name: 'During the reporting period, did the reporting fund or any of its controlled portfolio companies experience an event of default under any of its indentures, loan agreements or other instruments evidencing obligations for borrowed money?'
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.BRIDGE_LOAN]: {
    questionLevels: [
      {
        columns: {
          has_bridge_loans: {
            name: 'Does any controlled portfolio company of the reporting fund have in place one or more bridge loans or commitments (subject to customary conditions) for a bridge loan?',
            leve: 'a'
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.FINANCING_LOANS]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'If you responded “yes” to Question 75(a), identify each person that has provided all or part of any bridge loan or commitment to the relevant controlled portfolio company. For each such person, provide the applicable outstanding amount or commitment amount.',
        level: '(b)',
        columns: {
          person_code: {
            name: 'Name'
          },
          person_other_name: {
            name: 'Other'
          },
          drawn_amount: {
            name: 'Drawn amount'
          },
          undrawn_amount: {
            name: 'Undrawn amount'
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.BRIDGE_LOAN_PERSONS_IS_FINANCIAL_INDUSTRY]: {
    questionLevels: [
      {
        columns: {
          is_financial_industry_portfolio_company: {
            name: "Is any of the reporting fund's controlled portfolio companies a financial industryportfolio company?"
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.CONTROL_PORTFOLIO_COMPANIES]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: "If you responded “yes” to Question 76(a), then for each of the reporting fund's controlled portfolio companies that constitutes a financial industry portfolio company, provide the following information.",
        columns: {
          legal_name: {
            name: 'Legal Name'
          },
          street1: {
            name: 'Address of principal office (include city, state and country)'
          },
          naics_code: {
            name: 'NAICS code'
          },
          legal_entity_id: {
            name: 'LEI, if any'
          },
          debt_to_equity: {
            name: 'Debt-to-equity ratio of portfolio company'
          },
          gross_asset_value: {
            name: 'Gross asset value of portfolio company'
          },
          percentage_gross_asset_value: {
            name: '% of reporting fund’s gross assets invested in this portfolio company'
          },
          portfolio_company_beneficially_owned_percentage: {
            name: '% of portfolio company beneficially owned by the reporting fund'
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.PORTFOLIO_COMPANIES_BY_INDUSTRY]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: "Provide a breakdown of the reporting fund's investments in portfolio companies by industry, based on the NAICS codes of the companies.",
        columns: {
          naics_code: { name: 'NAICS code' },
          percentage_gross_asset_value: {
            name: '% of reporting fund’s total portfolio company investments'
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.INVESTED_AMOUNT]: {
    questionLevels: [
      {
        columns: {
          invested_amount: {
            name: 'If you or any of your related persons (other than the reporting fund) invest in any companies that are portfolio companies of the reporting fund, provide the aggregate dollar amount of these investments.'
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.GEOGRAPHICAL_BREAKDOWN_BY_REGION]: {
    questionLevels: [
      {
        name: "Provide a geographical breakdown of the gross value of the reporting fund's investments in portfolio companies (by percentage of the total gross value of the reporting fund's investments in portfolio companies).",
        level: '(a)',
        columns: {
          percent_nav_in_africa: { name: 'Africa', level: 'i' },
          percent_nav_in_asia_pacific: {
            name: 'Asia and Pacific (other than the Middle East)',
            level: 'ii'
          },
          percent_nav_in_europe_eea: { name: 'Europe (EEA)', level: 'iii' },
          percent_nav_in_europe_non_eea: { name: 'Europe (other than EEA)', level: 'iv' },
          percent_nav_in_middle_east: { name: 'Middle East', level: 'v' },
          percent_nav_in_north_america: { name: 'North America', level: 'vi' },
          percent_nav_in_south_america: { name: 'South America', level: 'vii' },
          percent_nav_in_supranational: { name: 'Supranational', level: 'viii' }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.GEOGRAPHICAL_BREAKDOWN_BY_COUNTRY]: {
    questionLevels: [
      {
        name: 'Provide the value of investments in the following countries held by the hedge funds that you advise (by percentage of the total net asset value of these hedge funds).',
        level: '(b)',
        columns: {
          percent_nav_in_brazil: { name: 'Brazil', level: 'i' },
          percent_nav_in_china: { name: 'China (including Hong Kong)', level: 'ii' },
          percent_nav_in_india: { name: 'India', level: 'iii' },
          percent_nav_in_japan: { name: 'Japan', level: 'iv' },
          percent_nav_in_russia: { name: 'Russia', level: 'v' },
          percent_nav_in_us: { name: 'United States', level: 'vi' }
        }
      }
    ]
  },
  ///========

  [SECTION_4_TABLE_NAMES.INVESTMENT_STRATEGY]: {
    questionLevels: [
      {
        name: 'Indicate the investment strategy in the drop-down menu that best describe the reporting fund’s investment strategy by percent of deployed capital, during the reporting period. If the reporting fund engages in more than one strategy, provide a good faith estimate of the percentage of the reporting fund’s deployed capital represented by each strategy.  (Select the investment strategy or strategies that best describe the reporting fund’s strategies, even if the categories below do not precisely match your characterization of the reporting fund’s strategy.  If you report all or part of the reporting fund’s strategy as “Other”, explain in Question 83.  The strategies listed are mutually exclusive (i.e., do not report the same portion of deployed capital in multiple strategies).  The total should add to 100%.) ',
        columns: {
          strategy_type: { name: 'Strategy' },
          percentage_capital: { name: '% of capital' }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.INVESTMENT_BY_COUNTRY]: {
    type: TABLE_TYPES.MULTIPLE,
    questionLevels: [
      {
        name: 'Identify , by ISO country code, each country to which the reporting fund’s investments in portfolio companies represent exposure of 10% or more of the reporting fund’s net asset value. ',
        columns: {
          country_code: { name: 'Country', level: 'sub1' },
          percentage_nav: { name: '% of NAV', level: 'sub2' }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.BORROWINGS_BY_CREDITOR_TYPE]: {
    questionLevels: [
      {
        name: "Provide the following information regarding the value of the reporting fund's borrowings and the types of creditors. (Do not net out amounts that the reporting fund loans to creditors or the value of collateral pledged to creditors. The percentages borrowed from the specified types of creditors should add up to approximately 100%.) ",
        columns: {
          total_amount: { name: 'Dollar amount of total borrowings', level: '(a)' },
          percentage_us_financial_institution: {
            name: 'Percentage borrowed from U.S. financial institutions ',
            level: '(b)'
          },
          percentage_non_us_non_financial_institution: {
            name: 'Percentage borrowed from non-U.S. financial institutions ',
            level: '(c)'
          },
          percentage_us_non_financial_institution: {
            name: 'Percentage borrowed from U.S. creditors that are not financial institutions',
            level: '(d)'
          },
          has_ability_to_borrow: {
            name: 'Does the reporting fund borrow or have the ability to borrow at the fund-level as an alternative or complement to financing of portfolio companies? If so, check “yes’ and complete subsection (g) of this question.  Otherwise, check “no’',
            level: '(f)'
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.BORROWING_OTHER_CASH_FINANCING]: {
    questionLevels: [
      {
        name: 'Borrowing Other Cash Financing info',
        level: 'g',
        columns: {
          secured_by: {
            name: 'Credit secured by the investments of the reporting fund '
          },
          amount: {
            name: 'Total amount available (in dollars) '
          },
          average_borrowed: {
            name: 'Average borrowed over the reporting period (in dollars)'
          }
        }
      }
    ]
  },

  // [SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS3]: {
  //   questionLevels: [
  //     {
  //       columns: {
  //         highest_debt_to_equity_ratio: {
  //           name: 'What is the highest debt-to-equity ratio of any controlled portfolio company in which the reporting fund invests (expressed as a decimal to the tenths place)?',
  //           level: 'a'
  //         },
  //         lowest_debt_to_equity_ratio: {
  //           name: 'What is the lowest debt-to-equity ratio of any controlled portfolio company in which the reporting fund invests (expressed as a decimal to the tenths place)?',
  //           level: 'b'
  //         }
  //       }
  //     }
  //   ]
  // },

  [SECTION_4_TABLE_NAMES.NATURE_OF_DEFAULT]: {
    questionLevels: [
      {
        name: 'Identify the nature of the default event (check all that apply):',
        level: '(a)',
        columns: {
          payment_default_by_fund: {
            name: 'Payment default of the reporting fund ',
            level: 'sub1'
          },
          payment_default_by_controlled_portfolio_company: {
            name: 'Payment default of a controlled portfolio company',
            level: 'sub2'
          },
          failure_to_uplold_borrowing_agreement: {
            name: 'A default relating to a failure to uphold terms under the applicable borrowing agreement, other than a failure to make regularly scheduled payments.',
            level: 'sub3'
          }
        }
      }
    ]
  },
  [SECTION_4_TABLE_NAMES.BRIDGE_LOAN_PERSONS]: {
    questionLevels: [
      {
        name: 'If you responded “yes” to Question 81(a), identify each person that has provided all or part of any bridge loan or commitment to the relevant controlled portfolio company.  For each such person, provide the applicable outstanding amount or commitment amount. ',
        level: '(b)',
        columns: {
          legal_name: { name: 'Legal Name of Counterparty', level: 'sub1' },
          name: { name: 'Name', level: 'sub1' },
          legal_entity_id: { name: 'LEI, if any', level: 'sub2' },
          affiliated_major_financial_institution: {
            name: 'Indicate below if the counterparty is affiliated with a major financial institution',
            level: 'sub3'
          },
          outstanding_amount: { name: 'Outstanding amount of financing, if drawn', level: 'sub5' },
          commitment_amount: { name: 'Amount of commitment, if undrawn', level: 'sub6' }
        }
      }
    ]
  }
};
